import React from 'react'
import { TypographyProps, TypographyTypeMap } from '@mui/material'
import { MarginSpacing } from 'commons/styles/spacing'
import { StyledTypography } from './styles'

export type DefaultTypographyComponent = TypographyTypeMap['defaultComponent']

export type Props<D extends React.ElementType> = {
  margin?: MarginSpacing
  component?: D
} & TypographyProps<D>

function Typography<D extends React.ElementType = DefaultTypographyComponent>({ margin, ...props }: Props<D>) {
  return <StyledTypography $margin={margin} {...props} />
}

export default Typography
